import React from 'react';
import { MdDeleteOutline } from 'react-icons/md';
import Button from '../buttons/Button';

const DeleteImageButton = ({ loading, onClick }) => {
  return (
    <Button
      disabled={loading}
      variant={'action2'}
      className="absolute bg-white justify-center items-center top-2 right-2 w-8 h-8 md:w-12 md:h-12"
      onClick={onClick}
    >
      <div className="text-sm flex justify-center items-center gap-2">
        <MdDeleteOutline size="20" />
      </div>
    </Button>
  );
};

export default DeleteImageButton;
